import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://cssbuy.biz";

const categoriasLinks = [
  "Shoes — Tênis e calçados de todas as marcas e estilos",
  "Hoodies/Sweaters — Moletons e blusas de frio",
  "T-Shirts — Camisetas de diversos estilos e marcas",
  "Jackets — Jaquetas, casacos e corta-ventos",
  "Pants/Shorts — Calças, shorts e bermudas",
  "Headwear — Bonés, gorros e acessórios de cabeça",
  "Sets — Conjuntos e kits completos",
  "Jersey — Camisas de futebol e esportivas",
  "Accessories — Acessórios diversos",
  "Bags — Bolsas, mochilas e malas",
  "Belts — Cintos de diversas marcas",
  "Perfumes — Perfumes e fragrâncias",
];

const faqLinks = [
  { q: "Os links do CSSBuy Spreadsheet são atualizados?", a: "Sim! Nossa planilha CSSBuy é atualizada diariamente. Nossa equipe verifica cada link manualmente para garantir que todos estejam funcionando e que os vendedores mantenham a qualidade dos produtos." },
  { q: "Como sei se um link é confiável?", a: "Todos os links em nossa planilha CSSBuy passam por verificação. Além disso, nossa equipe monitora avaliações da comunidade e histórico dos vendedores. Links de vendedores com problemas são removidos imediatamente." },
  { q: "Posso sugerir novos links para a planilha?", a: "Sim! A comunidade pode sugerir novos vendedores e produtos. Nossa equipe avalia cada sugestão e, se aprovada, adiciona à planilha CSSBuy. Isso torna nossa spreadsheet um recurso colaborativo e cada vez mais completo." },
];

export default function MelhoresLinksPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context":"https://schema.org","@type":"Article",
        "headline":"Melhores Links CSSBuy 2026: Coleção Completa por Categoria",
        "url": `${SITE_URL}/melhores-links`,
        "author":{"@type":"Person","name":"Equipe CSSBuy Brasil"},
        "datePublished":"2026-06-20","dateModified":"2026-06-27",
        "publisher":{"@type":"Organization","name":"CSSBuy Brasil","url": SITE_URL},
        "inLanguage":"pt-BR"
      })}} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context":"https://schema.org","@type":"BreadcrumbList",
        "itemListElement":[
          {"@type":"ListItem","position":1,"name":"Início","item": `${SITE_URL}/`},
          {"@type":"ListItem","position":2,"name":"Melhores Links CSSBuy","item": `${SITE_URL}/melhores-links`}
        ]
      })}} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context":"https://schema.org","@type":"FAQPage",
        "mainEntity":[
          {"@type":"Question","name":"Os links do CSSBuy Spreadsheet são atualizados?","acceptedAnswer":{"@type":"Answer","text":"Sim! Nossa planilha CSSBuy é atualizada diariamente. Nossa equipe verifica cada link manualmente para garantir que todos estejam funcionando e que os vendedores mantenham a qualidade dos produtos."}},
          {"@type":"Question","name":"Como sei se um link é confiável?","acceptedAnswer":{"@type":"Answer","text":"Todos os links em nossa planilha CSSBuy passam por verificação. Além disso, nossa equipe monitora avaliações da comunidade e histórico dos vendedores. Links de vendedores com problemas são removidos imediatamente."}},
          {"@type":"Question","name":"Posso sugerir novos links para a planilha?","acceptedAnswer":{"@type":"Answer","text":"Sim! A comunidade pode sugerir novos vendedores e produtos. Nossa equipe avalia cada sugestão e, se aprovada, adiciona à planilha CSSBuy. Isso torna nossa spreadsheet um recurso colaborativo e cada vez mais completo."}}
        ]
      })}} />
      <Navbar />
      <main>
        <article className="pt-24 pb-16 md:pt-28 md:pb-24">
          <div className="max-w-4xl mx-auto px-4 md:px-8 mb-6">
            <nav className="flex items-center gap-2 text-xs text-foreground-400">
              <Link to="/" className="hover:text-foreground-700 transition-colors cursor-pointer">Início</Link>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-foreground-600">Melhores Links CSSBuy</span>
            </nav>
          </div>
          <header className="max-w-4xl mx-auto px-4 md:px-8 mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4 whitespace-nowrap">Links</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">Melhores Links CSSBuy 2026: Coleção Completa por Categoria</h1>
            <p className="mt-4 text-foreground-500 text-base md:text-lg leading-relaxed max-w-2xl">Confira nossa coleção dos <strong>melhores links CSSBuy</strong> organizados por categoria: tênis, roupas, acessórios e muito mais. Todos verificados e atualizados em 2026.</p>
            <div className="flex flex-wrap items-center gap-4 mt-6 text-xs text-foreground-400">
              <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-user-line"></i>Equipe CSSBuy Brasil</span>
              <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-calendar-line"></i>Atualizado: Junho 2026</span>
              <span className="flex items-center gap-1.5 whitespace-nowrap"><i className="ri-time-line"></i>6 min de leitura</span>
            </div>
            <div className="mt-8 rounded-2xl overflow-hidden h-[300px] md:h-[420px]">
              <img src="https://readdy.ai/api/search-image?query=Organized%20link%20collection%20concept%20with%20multiple%20product%20cards%20displayed%20on%20warm%20minimalist%20surface%20soft%20natural%20lighting%20editorial%20style%20clean%20composition%20neutral%20cream%20background%20curated%20catalog%20aesthetic%20best%20selection%20theme&width=1200&height=600&seq=art-page-melhores-links&orientation=landscape" alt="Melhores Links CSSBuy" className="w-full h-full object-cover" />
            </div>
          </header>
          <div className="max-w-3xl mx-auto px-4 md:px-8">
            <div className="text-foreground-700 leading-relaxed space-y-8">
              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Os Melhores Links CSSBuy em um Só Lugar</h2>
                <p className="text-base leading-relaxed">
                  Encontrar <strong>melhores links CSSBuy</strong> pode ser uma tarefa demorada e frustrante. Por isso, nossa equipe dedicou centenas de horas para criar a coleção mais completa de <strong>CSSBuy links</strong> verificados e organizados por categoria, disponível gratuitamente em nossa <strong>planilha CSSBuy</strong>.
                </p>
              </section>
              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Categorias com os Melhores Links</h2>
                <p className="text-base leading-relaxed">Nossa <strong>spreadsheet CSSBuy</strong> cobre todas as categorias mais procuradas, com múltiplos vendedores verificados para cada tipo de produto:</p>
                <div className="mt-6 bg-background-100 rounded-2xl p-6">
                  <ul className="space-y-3">
                    {categoriasLinks.map((item, i) => (
                      <li key={i} className="flex items-start gap-3 text-sm">
                        <i className="ri-link-m text-primary-500 mt-0.5 flex-shrink-0"></i>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </section>
              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Como Acessar os Melhores Links CSSBuy</h2>
                <p className="text-base leading-relaxed">
                  Acessar os <strong>melhores links CSSBuy</strong> é simples: basta abrir nossa planilha, escolher a categoria desejada e copiar o link do produto que mais te interessa. Cole o link no CSSBuy, adicione ao carrinho e pronto! Nossa planilha é constantemente atualizada com novos links e remoção de itens indisponíveis.
                </p>
              </section>
              <section>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">Perguntas Frequentes</h2>
                <div className="space-y-4">
                  {faqLinks.map((item, i) => (
                    <div key={i} className="bg-background-100 rounded-xl p-5">
                      <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.q}</h4>
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                    </div>
                  ))}
                </div>
              </section>
              <section>
                <div className="bg-foreground-900 rounded-3xl p-8 md:p-10 text-center">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">Acesse os Melhores Links CSSBuy</h2>
                  <p className="text-background-50/60 text-sm md:text-base max-w-lg mx-auto mb-6">Descubra nossa coleção completa dos melhores links CSSBuy organizados por categoria e comece a comprar com segurança.</p>
                  <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer">cssbuy sheet<i className="ri-arrow-right-up-line ml-2"></i></a>
                    <Link to="/" className="px-8 py-3.5 rounded-full border border-background-50/20 text-background-50/70 text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer">← Voltar ao Início</Link>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}